import { financeAPI } from "../../axios";

export const actions = {
    createSLType(context, data) {
        return financeAPI.post(`SubsidiaryLedgerType/Create`, data);
    },
    getSLTypes(context) {
        return financeAPI.get(`SubsidiaryLedgerType/All`);
    },
    getSLTypeByCategory(context, categoryId) {
        return financeAPI.get(`SubsidiaryLedgerType/ByCategory/${categoryId}`);
    },
    getSingleSLType(context, id) {
        return financeAPI.get(`SubsidiaryLedgerType/${id}`);
    },
    removeSLType(context, categoryId) {
        return financeAPI.delete(`SubsidiaryLedgerType/Remove/${categoryId}`);
    },
    updateSLType(context, data) {
        return financeAPI.put(`SubsidiaryLedgerType/Update/${data.id}`, data);
    },
}